import action from '../commons/constantActionStatus';

export const getHistoryConstantRequestAction = () => {
    return {
        type: action.GET_HISTORY_CONSTANTS_REQUEST,
        status: 'GET_HISTORY_CONSTANTS_REQUEST',
        requestState: true,
    };
};

export const getHistoryConstantSuccessAction = (result, citiesResult) => {
    return {
        type: action.GET_HISTORY_CONSTANTS_SUCCESS,
        status: 'History configs retrieved sucessfully',
        result,
        cities: citiesResult,
        requestState: false,
    };
};

export const getHistoryConstantFailureAction = (error) => {
    return {
        type: action.GET_HISTORY_CONSTANTS_FAILURE,
        status: 'Get History configs failure',
        error,
        requestState: false,
    };
};

export const createConstantRequestAction = (name, label) => {
    return {
        type: action.CREATE_CONSTANTS_REQUEST,
        status: 'CREATE_CONSTANTS_REQUEST',
        requestState: true,
        payload:{
            name,label
        }
    };
};

export const createConstantSuccessAction = (result, label) => {
    return {
        type: action.CREATE_CONSTANTS_SUCCESS,
        status: 'Constant Created sucessfully',
        result,
        label,
        requestState: false,
    };
};

export const createConstantFailureAction = (error) => {
    return {
        type: action.CREATE_CONSTANTS_FAILURE,
        status: 'Get History configs failure',
        error,
        requestState: false,
    };
};

export const resetConstantState = () => {
    return {
        type: action.RESET_CONSTANTS_REQUEST
    };
};
